import pick from 'lodash/pick';
import BaseStore from 'vendor/cnpm/fluxible.v0-4/addons/BaseStore';

export type InvoiceFormData = {
  streetAddress: string;
  addressLine2: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  taxType: string;
  taxId: string;
  poNumber: string;
};

export type InvoiceResponse = {
  invoiceHostedUrl: string;
  invoicePdfUrl: string;
  contractOrderId: string;
};

const SERIALIZED_PROPS: Array<keyof SelfServeInvoiceStore$DehydratedState> = ['formData', 'invoiceResponse'];

type SelfServeInvoiceStore$DehydratedState = {
  formData: InvoiceFormData;
  invoiceResponse: InvoiceResponse | null;
};

class SelfServeInvoiceStore extends BaseStore {
  declare formData: InvoiceFormData;

  declare invoiceResponse: InvoiceResponse | null;

  declare emitChange: () => void;

  static storeName = 'SelfServeInvoiceStore';

  static handlers = {
    UPDATE_INVOICE_FORM: 'onUpdateInvoiceForm',
    UPDATE_INVOICE_RESPONSE: 'onUpdateInvoiceResponse',
    RESET_INVOICE_FORM: 'onResetInvoiceForm',
  };

  onUpdateInvoiceForm(fields: Partial<InvoiceFormData>) {
    this.formData = Object.assign({}, this.formData, fields);
    this.emitChange();
  }

  onUpdateInvoiceResponse(response: InvoiceResponse) {
    this.invoiceResponse = response;
    this.emitChange();
  }

  onResetInvoiceForm() {
    this.initialize();
    this.emitChange();
  }

  dehydrate(): SelfServeInvoiceStore$DehydratedState {
    return pick(this, ...SERIALIZED_PROPS);
  }

  rehydrate(state: SelfServeInvoiceStore$DehydratedState) {
    Object.assign(this, pick(state, ...SERIALIZED_PROPS));
  }

  initialize() {
    this.formData = {
      streetAddress: '',
      addressLine2: '',
      city: '',
      state: '',
      zipCode: '',
      country: '',
      taxType: '',
      taxId: '',
      poNumber: '',
    };
    this.invoiceResponse = null;
  }

  getFormData(): InvoiceFormData {
    return this.formData;
  }

  getField<K extends keyof InvoiceFormData>(fieldName: K): InvoiceFormData[K] {
    return this.formData[fieldName];
  }

  getInvoiceResponse(): InvoiceResponse | null {
    return this.invoiceResponse;
  }
}

export default SelfServeInvoiceStore;
